import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

export type AlertMessageVariant = 'danger' | 'warning' | 'info' | 'success';

@Component({
    selector: 'ngx-alert-message-inline',
    templateUrl: './alert-message-inline.component.html',
    styleUrls: ['./alert-message-inline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertMessageInlineComponent {
    @Input() icon: string = 'alert-circle';
    @Input() message: string;
    @Input() variant: AlertMessageVariant = 'info';
    @Input() linkText: string;
    @Input() buttonText: string;
    @Input() buttonIcon: {icon: string; pack?: string};
    @Input() brightStyle: boolean = false;
    @Input() showCloseBtn: boolean = false;

    @Output() onLinkClicked = new EventEmitter();
    @Output() onCloseClicked = new EventEmitter<boolean>();
    @Output() onButtonClicked = new EventEmitter<boolean>();

    onClick(event) {
        this.onLinkClicked.emit(event);
    }
}
